import { diContainer } from "@/core/di";
import AbstractDownloadHandler from "./AbstractDownloadHandler";
import { MimeTypes, IDownload } from "../types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
import { injectable } from "inversify";

@injectable()
export default class ZIPDownloadHandler extends AbstractDownloadHandler {
  handle(mimeType: MimeTypes): IDownload | null {
    if (mimeType === MimeTypes.ZIP)
      return diContainer.get<IDownload>(DITypes.DOWNLOAD_ZIP);

    return super.handle(mimeType);
  }
}
